module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/sp/item_03_b5fcc0d29e5331d78bd3dcdf6d0196e6.jpg";